import { Button, DragList, Flex, IconButton, InputContainer, Text } from 'components'
import { DotsDragIcon, PlusIcon, XMarkIcon } from 'components/icons'
import { TraitValue } from 'types'
import { randomString } from 'utils'

interface Props {
  onChange: (values: TraitValue[]) => void
  onSelect: (index: number) => void
  values: TraitValue[]
}

export default function TraitValueList({ onChange, onSelect, values }: Props) {
  function handleAddValue() {
    const newValue: TraitValue = {
      id: randomString(),
      title: { en: 'New Value' },
    }
    onChange([...values, newValue])
  }

  function handleRemoveValue(id: string) {
    const updated = values?.filter(item => item.id !== id) || []
    onChange(updated)
  }

  return (
    <InputContainer label="Manage Values">
      <Flex direction="column" border="1px solid rgba(23, 23, 23, 0.20)" borderRadius="sm">
        <DragList
          items={values || []}
          onChange={onChange}
          renderItem={item => (
            <Flex
              flex={1}
              px={2}
              py={1}
              gap={2}
              cursor="pointer"
              align="center"
              justify="space-between"
              borderRadius={4}
              overflow="hidden"
              onClick={() => onSelect(values!.findIndex(v => v.id === item.id))}
            >
              <DotsDragIcon cursor="grab" />
              <Text flex={1}>{item.title.en}</Text>
              <IconButton
                variant="ghost"
                color="inherit"
                size="sm"
                aria-label="Remove name"
                icon={<XMarkIcon />}
                onClick={e => {
                  e.stopPropagation()
                  handleRemoveValue(item.id)
                }}
              />
            </Flex>
          )}
        />

        <Button borderRadius="sm" leftIcon={<PlusIcon />} variant="ghost" onClick={handleAddValue}>
          Add New Value
        </Button>
      </Flex>
    </InputContainer>
  )
}
